import * as moment from "moment";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import { ISyncNotificationState } from "source/app/presentation/Header/Center/Sync/ISyncNotificationState";
import { SetState } from "source/app/services/UI/State/SetState";
import { State } from "source/app/services/UI/State/State";
import { ICalendarState } from "../ICalendarState";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { CalendarEvent } from "../CalendarEventUtils/CalendarEvent";

export function HandleCurrentEventIsComplete() {
    const textToShow = GetNextEventCountdown();

    SetState<ISyncNotificationState>(ESharedFunction.SyncNotification_state, {
        syncNotificationElement: (
            <span style={{ opacity: 0.5, color: `greenyellow` }}>
                {textToShow}
            </span>
        ),
    });
}

function GetNextEventCountdown() {
    const calendar = State.ReadClass<ICalendarState>(ESharedComponent.Calendar);

    if (!calendar) {
        return `?`;
    }

    const calendarEvents = calendar.state.eventData.map(
        (eventData) => new CalendarEvent(eventData)
    );

    const nextEvents = calendarEvents.filter(
        (ce) =>
            ce.IsToday && ce.StartingInMinutes <= 60 && ce.StartingInMinutes > 0
    );

    if (nextEvents.length === 0) {
        return `?`;
    }

    const nextEvent = nextEvents[0];
    const minutesToEvent = nextEvent.StartingInMinutes;
    return `${minutesToEvent}m → ${nextEvent.eventData.name}`;
}
